
import "./LightBox.scss";  

export default (userOptions = {}) => {

  const options = Object.assign({
    animationDuration : 300,
  },userOptions)

  function createNavLink( items = [], index = 0, content ="", className ="" ) {

    const link = document.createElement('a');
    link.href = items[index].href;
    link.innerHTML = content;
    if(className) link.classList.add(className);
    link.addEventListener('click', e =>{
      e.preventDefault();
      const contentSelector = items[index].dataset.lightboxShow;  
      const content = getContent(contentSelector,e.currentTarget.href);
      show( content, { items,index })
    })
    return link;
  }

  function getContent(contentSelector, href) {
    if(contentSelector) {
      var content = document.querySelector(`[data-lightbox-content="${contentSelector}"]`);
    } else if(href)  {
      var imageUrl = href.match(/(?:.*\.(?:jpg|jpeg|png|svg))/g);
      if(imageUrl) var content = `<img src="${imageUrl}" />`; 
    }
    return content;
  }
  
  function onLinkClick(e) {
    
    const gallerySlug = e.currentTarget.dataset.lightboxGallery;
    let gallery = false;
    if(gallerySlug) {
  
      const items = document.querySelectorAll(`[data-lightbox-gallery="${gallerySlug}"]`);
      const index = [...items].findIndex( el => el == e.currentTarget)
      gallery = {
        items,
        index,
      }
    }
  
    const contentSelector = e.currentTarget.dataset.lightboxShow; 
    const contentLabel = e.currentTarget.dataset.lightboxLabel;     
    const content = getContent(contentSelector,e.currentTarget.href)

    if(content) {
      e.preventDefault();
      show( content,  gallery, contentLabel);
    }
  }

  const LightBoxContainer = document.createElement('div');
  LightBoxContainer.classList.add('LightBox');

  const LightBoxContent = document.createElement('div');
  LightBoxContent.classList.add('LightBox__content');

  const LightBoxLabel = document.createElement('div');
  LightBoxLabel.classList.add('LightBox__label');

  const LightBoxClose = document.createElement("div");
  LightBoxClose.classList.add("LightBox__close");
  LightBoxClose.innerHTML = "<a href=\"#\" data-lightbox-close>Zamknij</a>"

  const innerContainer = document.createElement("div");
  innerContainer.classList.add("LightBox__inner-content");

  const contentWrapper = document.createElement("div");
  innerContainer.appendChild(contentWrapper);

  LightBoxContent.appendChild(LightBoxClose);
  LightBoxContent.appendChild(innerContainer);

  LightBoxContainer.appendChild(LightBoxContent);

  const show = (content,gallery = false, label = false) => {
    document.body.style.overflow = "hidden";
    let HTML = "";
    if (typeof content == "string") {
      HTML = content;
    } else if(content instanceof HTMLElement) {
      HTML = content.innerHTML;
    }
    if(typeof options.beforeContentAppend == "function" ) HTML = options.beforeContentAppend(HTML);
    contentWrapper.innerHTML = HTML;
    if(label){
      LightBoxLabel.innerText = label;
      contentWrapper.appendChild(LightBoxLabel);
    }
    const {items, index} = gallery;
    if(items) {
      if( index >= 1) innerContainer.append(createNavLink(gallery.items, gallery.index -1,"Poprzedni", "lightbox__prev"));
      if( index < items.length - 1) innerContainer.append(createNavLink(gallery.items,gallery.index +1 ,"Następny", "lightbox__next"));
    }

    document.body.appendChild(LightBoxContainer);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        LightBoxContent.classList.add('LightBox__content--on')
      })
    });
  }

  const hide = () => {
    LightBoxContent.classList.remove('LightBox__content--on')
    setTimeout(() => {   
      document.body.style.overflow = "auto";
      LightBoxContainer.remove()
    },options.animationDuration);
  }

  LightBoxContent.addEventListener('click', e=> {
    e.stopPropagation();
    const close = e.target.closest('[data-lightbox-close]');
    if (close) {
      e.preventDefault();
      hide();
    }
  })

  LightBoxContainer.addEventListener('click', e=> {
    e.preventDefault();
    hide();
  })

  const closeBtns = document.querySelectorAll('[data-lightbox-close]');
  closeBtns.forEach(btn => btn.addEventListener('click', e => {
    e.preventDefault();
    hide();
  }));

  const links = document.querySelectorAll('[data-lightbox-show]');
  links.forEach(link => link.addEventListener('click', onLinkClick));

  return {
      show,
      hide,
  }
}